const STORAGE_KEY = 'vue-session-key'
const DATA_KEY = 'vue-session-data'

function readData () {
  try {
    const raw = localStorage.getItem(DATA_KEY)
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

function writeData (data) {
  localStorage.setItem(DATA_KEY, JSON.stringify(data))
}

export function createSessionPlugin () {
  return {
    install (app) {
      const session = {
        start () {
          if (!localStorage.getItem(DATA_KEY)) {
            writeData({})
          }
          localStorage.setItem(STORAGE_KEY, '1')
        },
        get (key) {
          return readData()[key]
        },
        getAll () {
          return { ...readData() }
        },
        set (key, value) {
          const data = readData()
          data[key] = value
          writeData(data)
          localStorage.setItem(STORAGE_KEY, '1')
        },
        remove (key) {
          const data = readData()
          delete data[key]
          writeData(data)
        },
        clear () {
          localStorage.removeItem(DATA_KEY)
          localStorage.removeItem(STORAGE_KEY)
        },
        destroy () {
          localStorage.removeItem(DATA_KEY)
          localStorage.removeItem(STORAGE_KEY)
        },
        exists () {
          return !!localStorage.getItem(STORAGE_KEY)
        }
      }

      app.config.globalProperties.$session = session
      app.provide('$session', session)
    }
  }
}
